import React from "react";
import { useNavigate } from "react-router-dom";
import Hero from "../../../components/ui/Hero.jsx";
import Card from "../../../components/ui/Card.jsx";

const UPLOAD_OPTIONS = [
  {
    code: "btl",
    label: "BTL",
    desc: "Buy-to-Let mortgages — manual entry or CSV bulk upload",
    path: "/lender/upload/btl/manual",
  },
  {
    code: "if",
    label: "Invoice Finance",
    desc: "Bulk upload from XLSX/CSV",
    path: "/lender/upload/if/csv",
  },
];

export default function UploadIndex() {
  const navigate = useNavigate();
  return (
    <>
      <Hero
        title="Upload Products"
        subtitle="Choose a product type to get started. BTL opens manual entry — you can switch to CSV bulk upload from there."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {UPLOAD_OPTIONS.map((option) => (
          <Card key={option.code} className="relative p-6">
            <div className="text-lg font-semibold text-slate-900">
              {option.label}
            </div>
            <p className="text-sm text-slate-600 mt-1">{option.desc}</p>
            <button
              type="button"
              className="mt-4 px-4 py-2 rounded-lg font-semibold bg-sky-600 text-white hover:bg-sky-700"
              onClick={() => navigate(option.path)}
            >
              Get started
            </button>
          </Card>
        ))}
      </div>
      <Card className="p-6 flex items-center justify-between mt-4">
        <div className="text-gray-700">Or browse all product categories.</div>
        <button
          className="px-4 py-2 rounded-lg border border-sky-200 text-sky-800 font-semibold hover:bg-sky-50"
          onClick={() => navigate("/lender/upload/select")}
        >
          Select Product
        </button>
      </Card>
    </>
  );
}
